'use strict';
import { module } from '../app';

module
  .factory('diagramViewModel', [
    'localStorage', 'Diagram', 'modalService', 'eventsMgr', '$ionicLoading', function (localStorage, Diagram, modalService, eventsMgr, $ionicLoading) {
      let vm = function () {
        let self = this;
        self.problemCodes = {
          m: 'Mole',
          l: 'Lump',
          s: 'Scar',
          p: 'Pain',
          q: 'Square',
          mc: 'Mastectomy',
          rs: 'ReductionScar'
        };

        self.problems = [
          {value: 'm', icon: 'ion-record'},
          {value: 'l', icon: 'ion-ios-circle-outline'},
          {value: 'p', icon: 'ion-pain'},
          {value: 'mc', icon: 'ion-m-letter'},
          {value: 'rs', icon: 'ion-reduction-scar'},
          {value: 'q', icon: 'ion-ios-square-outline'}
        ];

        self.zoom = 0;
        self.loading = false;
        self.commentText = '';

        self.mode = '';

        self.turnMode = function (m) {
          if (self.mode == m) {
            self.mode = '';
            return;
          }

          self.mode = m;
        };

        self.getMode = function () {
          return self.mode;
        };
        self.drawScar = function (result) {
          if (result.path.length < 3) {
            return;
          }

          let pos = result;
          let type = 's';

          self.problemsList.push({Settings: pos, Type: self.problemCodes[ type ]});
          self.mode = '';
        };

        self.addProblem = function (type, pos) {
          self.problemsList.push({Settings: pos, Type: self.problemCodes[ type ]});
          self.problems = angular.copy(self.problems);
          self.mode = '';
        };

        self.dropped = function (el, pos) {
          let type = angular.element(el).scope().el.value;

          self.addProblem(type, pos);
        };

        self.applyZoom = function (level) {
          self.zoom += level;
        };

        self.init = function (ssn, sdate) {
          self.ssn = ssn;
          self.sdate = sdate;
          self.problemsList = [];
          $ionicLoading.show({
            template: 'Loading...'
          });
          Diagram.get(self.ssn, self.sdate).then(resp => {
            resp.data.Problems.forEach(item => {
              item.Settings = JSON.parse(item.Settings);
            });
            self.problemsList = resp.data.Problems;
            $ionicLoading.hide();
          }, () => {
            $ionicLoading.hide();
            modalService.showAlert('Cannot load patient diagram');
          });
        };

        self.startSaving = function () {
          eventsMgr.send('diagram:startSaving');
        };

        self.save = function (svg) {
          self.loading = true;
          let problems = angular.copy(self.problemsList);
          problems.forEach(function (item) {
            item.Settings = JSON.stringify(item.Settings);
          });
          Diagram.saveForPatient(
            self.ssn ? self.ssn : self.patient.Ssn,
            self.sdate ? self.sdate : self.patient.SDate,
            self.worklistId ? self.worklistId : 0,
            svg ? svg : '',
            {
              Problems: problems
            }
          ).then(resp => {
            resp.data.Problems.forEach(item => {
              item.Settings = JSON.parse(item.Settings);
            });
            self.problemsList = resp.data.Problems;

            self.loading = false;
            eventsMgr.send('diagram:saved');
          });

          /*Diagram.generateImageForPatient(self.ssn, self.sdate, svg).then(function (resp) {
           });*/
        };

        self.clear = function () {
          Diagram.save(self.worklistId, { Problems: [], IsDiagramChanged: true, IsDiagramEmpty: true });
          self.problemsList = [];
          self.clearConfirmationVisible = false;
        };


        self.startClearing = function () {
          modalService.showConfirmation(() => {
            self.clear();
          }, 'Are you sure to clear diagram?');
        };


        self.addComment = function () {
          self.selectedElement.Comments = self.commentText;
          eventsMgr.send('diagram:deselectItem');
        };

        self.revertComment = function () {
          self.commentText = self.selectedElement.Comments;
        };

        self.commentChanged = function () {
          return self.selectedElement && self.commentText !== self.selectedElement.Comments;
        };

        self.removeComment = function (item) {
          modalService.showConfirmation(function () {
            item.Comments = null;
          }, 'Are you sure you want to delete this comment?');
        };
      };

      return vm;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/diagram.js